import { AxiosService } from '@/shared/utils'
import { AxiosRequestConfig } from 'axios'
import { UserInfoType, UserEditType, StatisticFilterType } from '@/shared/types'

class UsersApi extends AxiosService {
  constructor(config?: AxiosRequestConfig) {
    super(config)
  }

  public getAllUsers(search: string) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/users/list',
      params: {
        search,
        count: 50,
      },
    })
  }

  public updateUser(user: UserEditType) {
    const { id, token, ...userInfo } = user

    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/users/update',
      data: {
        ...userInfo,
        user_id: id,
        api_token: token,
      },
    })
  }

  public getUsers(organizationId: number, search, filter) {
    const { dateFrom, dateTo } = filter

    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/users',
      params: {
        organization_id: organizationId,
        search,
        reports_date_from: dateFrom,
        reports_date_to: dateTo,
        count: 50,
      },
    })
  }

  public getUserReports(userId: number, organizationId: number) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/organizations/user/reports',
      params: {
        user_id: userId,
        organization_id: organizationId,
      },
    })
  }

  public getUsersCount() {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/users/users/count',
    })
  }

  public createUser(user: UserInfoType) {
    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/users/store',
      data: user,
    })
  }

  public getUserStatistic(
    organizationId: number,
    userId: number,
    filter: StatisticFilterType
  ) {
    const { dateFrom, dateTo } = filter

    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/users/statistics',
      params: {
        organization_id: organizationId,
        user_id: userId,
        date_from: dateFrom,
        date_to: dateTo,
      },
    })
  }
}

export const usersApi = new UsersApi({
  baseURL:
    process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URI : '',
  withCredentials: true,
})
